import { jsx as _jsx } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import { OpenAiProviderForm } from '@modules/ai/common/forms';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { GeneralProviderFormWrapper } from '../common/general-provider-form-wrapper';
export function OpenAiConfiguration(props) {
    const { provider, className, form, availableProvider } = props;
    const { fieldState } = useController({ name: `provider.openai`, control: form.control });
    return (_jsx(GeneralProviderFormWrapper, { label: "Open AI", withTestConnection: true, className: className, fieldState: fieldState, ...props, ...assignTestId(provider.id), children: _jsx(OpenAiProviderForm, { form: form, availableProvider: availableProvider }) }));
}
